import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/sound/importer/soundImporterActions';

export default importerReducers(actions);
